import { cva } from '@/styled-system/css';

export const inputRecipe = cva({
  base: {
    'backgroundColor': {
      base: 'Input.bg.default',
    },
    'color': { base: 'text.neutral' },
    'cursor': 'text',
    'boxShadow': {
      base: 'inset 0 0 0 {borderWidths.default} var(--shadow-color)',
    },
    'boxShadowColor': {
      base: 'Input.border.default',
    },
    'textStyle': 'body',
    'width': '100%',
    '_placeholder': {
      color: { base: 'Input.text.placeholder' },
    },
    '&.edge-autofilled, &:-webkit-autofill, &:autofill': {
      // Override user agent stylesheet autofill background
      // This also preserves the border color
      boxShadow: {
        base: 'inset 0 0 0 {borderWidths.default} var(--shadow-color), inset 0 0 0 1000px {colors.Input.bg.default}',
      },
    },
    'transition': {
      _motionReduce: 'none',
      _motionSafe: 'box-shadow 200ms ease,',
    },
  },
  variants: {
    disabled: {
      true: {
        opacity: 'disabled',
        cursor: 'default',
      },
      false: {
        'backgroundColor': {
          _hover: 'Input.bg.hover',
          _focus: 'bg.neutral',
          _active: 'bg.neutral',
        },
        '&.edge-autofilled, &:-webkit-autofill, &:autofill': {
          // Override user agent stylesheet autofill background
          // This also preserves the border color
          boxShadow: {
            _hover:
              'inset 0 0 0 {borderWidths.default} var(--shadow-color), inset 0 0 0 1000px {colors.Input.bg.hover}',
            _focus:
              'inset 0 0 0 {borderWidths.default} var(--shadow-color), {shadows.focus}, inset 0 0 0 1000px {colors.bg.neutral}',
            _active:
              'inset 0 0 0 {borderWidths.default} var(--shadow-color), inset 0 0 0 1000px {colors.bg.neutral}',
          },
        },
        'boxShadow': {
          _focusVisible: 'inset 0 0 0 {borderWidths.default} var(--shadow-color), {shadows.focus}',
        },
        'boxShadowColor': {
          _hover: 'Input.border.hover',
          _focus: 'border.action.hero.selected.default',
          _active: 'border.action.hero.selected.default',
        },
        '&:is(:hover:active), &:is(:hover:focus)': {
          backgroundColor: 'bg.neutral',
        },
      },
    },
    error: {
      true: {
        backgroundColor: {
          base: 'Input.bg.error',
        },
        boxShadowColor: {
          base: 'Input.border.error',
        },
      },
      false: {},
    },
    fluid: {
      true: {},
      false: {
        width: 'auto',
      },
    },
    readOnly: {
      true: {
        backgroundColor: 'bg.invisible',
        boxShadowColor: 'border.invisible',
      },
      false: {},
    },
    size: {
      sm: {
        borderRadius: 'obj.default',
        paddingBlock: 'Input.sm.padding.vert',
        paddingInline: 'default',
      },
      md: {
        borderRadius: 'obj.default',
        paddingBlock: 'Input.md.padding.vert',
        paddingInline: 'default',
      },
      lg: {
        borderRadius: 'obj.default',
        paddingBlock: 'default',
        paddingInline: 'default',
      },
    },
  },
  compoundVariants: [
    {
      size: 'sm',
      readOnly: true,
      css: {
        paddingInline: 'none',
      },
    },
    {
      size: 'md',
      readOnly: true,
      css: {
        paddingInline: 'none',
      },
    },
    {
      size: 'lg',
      readOnly: true,
      css: {
        paddingInline: 'none',
      },
    },
    {
      disabled: false,
      error: true,
      css: {
        'backgroundColor': {
          _hover: 'Input.bg.errorHover',
          _active: 'bg.neutral',
          _focus: 'bg.neutral',
        },
        'boxShadowColor': {
          _active: 'Input.border.errorActive',
          _focus: 'Input.border.errorActive',
          _hover: 'Input.border.errorHover',
        },
        '&.edge-autofilled, &:-webkit-autofill, &:autofill': {
          // Override user agent stylesheet autofill background
          // This also preserves the border color
          boxShadow: {
            _hover:
              'inset 0 0 0 {borderWidths.default} var(--shadow-color), inset 0 0 0 1000px {colors.Input.bg.errorHover}',
            _focus:
              'inset 0 0 0 {borderWidths.default} var(--shadow-color), {shadows.focus}, inset 0 0 0 1000px {colors.bg.neutral}',
            _active:
              'inset 0 0 0 {borderWidths.default} var(--shadow-color), inset 0 0 0 1000px {colors.bg.neutral}',
          },
        },
        '&:is(:hover:active)': {
          backgroundColor: 'Input.bg.errorHover',
        },
      },
    },
    {
      disabled: false,
      readOnly: true,
      css: {
        backgroundColor: {
          _active: 'bg.invisible',
          _focus: 'bg.invisible',
          _hover: 'bg.invisible',
        },
      },
    },
  ],
});
